export const GET_COMUNICADO_CODIGO_TELA_REQUEST = '@notice/GET_COMUNICADO_CODIGO_TELA_REQUEST';
export const GET_COMUNICADO_CODIGO_TELA_SUCCESS = '@notice/GET_COMUNICADO_CODIGO_TELA_SUCCESS';
export const COMUNICADO_TELA_CLOSE = '@notice/COMUNICADO_TELA_CLOSE';
